import React, { ReactNode } from "react";

import { Box, BoxProps } from "@catchoftheday/cg-components";
import { styled } from "@catchoftheday/theme";
import { removeProperty } from "@catchoftheday/utilities";

type ProductPriceAsideProps = {
  children?: ReactNode;
  hasPromotion?: boolean;
  showArrow?: boolean;
  large?: boolean;
} & BoxProps;

export const ProductPriceAside = ({
  children,
  showArrow,
  large,
  ...flexProps
}: ProductPriceAsideProps) => {
  const content = children || " ";

  const ArrowPriceBox = styled(Box)`
    &::after {
      content: "";
      display: block;
      position: absolute;
      z-index: 1;
      top: 0;
      bottom: 0;
      left: 100%;
      width: 0.21875em;
      height: 100%;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      ${showArrow &&
      'background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2050%20100%22%20preserveAspectRatio%3D%22none%22%3E%3Cpolygon%20points%3D%220%2C%200%2050%2C%2050%200%2C%20100%22%20fill%3D%22%23fff%22%20%2F%3E%3C%2Fsvg%3E")'}
    }
  `;

  return (
    <ArrowPriceBox
      display="flex"
      position="relative"
      flex="0 1 auto"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      lineHeight="1"
      textAlign="center"
      backgroundColor="white"
      color="typography.text"
      paddingLeft={large ? "14px" : "10px"}
      paddingRight={large ? "9px" : "6px"}
      border="1px solid"
      borderColor="ui.borderColor"
      {...removeProperty(flexProps, "ref")}
    >
      {content}
    </ArrowPriceBox>
  );
};
